var map = {
	"./negative.gif": "NK4y",
	"./neutral.gif": "SnIB",
	"./positive.gif": "xvK7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZOR1";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.gif$
// module id = ZOR1
// module chunks = 1